import { APPLICATION_CONSTANTS, PATHS } from 'AppConstants';
import { MICE_ACTION_CONSTANTS } from 'reduxStore/actionConstants';
import { actionCreator, failedFor, successFor } from 'reduxStore/reduxUtil';
import { saveServerLogs, getCookie } from 'UtilityComponents/Util';
import { getccbAxiosConfig } from '../../apisSetup/ccbConfig';
import { defaultRequestObj } from '../../pages/mice/config';
import { filterHotelSearch } from 'UtilityComponents/miceUtils';

const ccbAxiosApiCaller = getccbAxiosConfig(true, {
	'deviceId': getCookie('dvid')
}, false);

export const postFormDataSuccess = actionCreator(successFor(MICE_ACTION_CONSTANTS.POST_DATA));
export const postFormDataFailure = actionCreator(failedFor(MICE_ACTION_CONSTANTS.POST_DATA));

export const postFormData = (payloadData) => async (dispatch) => {
	let response = null;
	let error = false;
	try {
		dispatch({
			type: MICE_ACTION_CONSTANTS.POST_DATA
		});
		response = await ccbAxiosApiCaller.post(PATHS.QUERY_FORM_REQUEST, payloadData);
		let responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			dispatch(postFormDataSuccess());
		} else {
			error = true;
		}
	} catch (e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.QUERY_FORM_REQUEST);
	} finally {
		if (error) {
			dispatch(postFormDataFailure());
		}
	}
};

export const showModal = actionCreator(MICE_ACTION_CONSTANTS.SHOW_MODAL);

export const queryFormApi = async (queryData) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.post(PATHS.QUERY_FORM_REQUEST, queryData);
	} catch (e) {
		const errorMsg = e ? e.message : APPLICATION_CONSTANTS.GENERIC_API_ERROR;
		response = { error: errorMsg };
		saveServerLogs(e.stack, 'error', PATHS.QUERY_FORM_REQUEST);
	}
	return response;
};

export const querySearchApiSuccess = actionCreator(successFor(MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA));
export const querySearchApiFailure = actionCreator(failedFor(MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA));

export const querySearchApi = (queryData = defaultRequestObj, ssr = false) => async (dispatch, _, axiosInstance) => {
	let response = null;
	let error = false;
	try {
		dispatch({
			type: MICE_ACTION_CONSTANTS.HOTEL_SEARCH_DATA
		});
		axiosInstance.defaults.headers.common['deviceId'] = getCookie('dvid');
		response = await axiosInstance.post(PATHS.DESTINATION_SEARCH, queryData);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			const formattedData = filterHotelSearch(responseData);
			dispatch(querySearchApiSuccess({ formattedData, ssr }));
		} else {
			error = true;
		}
	} catch (e) {
		error = true;
		saveServerLogs(e.stack, 'error', PATHS.DESTINATION_SEARCH);
	} finally {
		if (error) {
			dispatch(querySearchApiFailure());
		}
	}
};

export const updateFilterObj = (data) => ({
	type: MICE_ACTION_CONSTANTS.UPDATE_FILTER_SEARCH_DATA,
	payload: data
});

export const updateSsr = (data) => ({
	type: MICE_ACTION_CONSTANTS.UPDATE_SSR,
	payload: data
});

export const updateSelectedHotel = (data) => ({
	type: MICE_ACTION_CONSTANTS.UPDATE_SELECTED_HOTEL_DATA,
	payload: data
});
